var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookStoreHome2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 890 704",
    width: 890,
    height: 704,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m490.49 571.61c0 0-26.09 52.34-8.19 101.65l214.14-69.23c0 0-18.07-33.71-1.2-75.27z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m706.26 457.09l-269.48 42.92c0 0-15.64 49.57 0 76.85l277.06-46.94c0 0-6.58-34.9-7.58-72.83z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m674.9 336.12l-209.17 44.12c0 0-31.94 59.89 8.98 96.82l202.61-55.9z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m666.34 252.49l-238.54 30.94c0 0-27.95 52.9 6.99 74.86l233.55-37.93c0 0-2-70.86-2-67.87z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m620.17 114.17l-91.8 25.22v47.9 5.99l90.53-28.69z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m457.25 88.73c0 0-16.18 22.56-3.43 45.61l162.83-26.97 2.45-47.09z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{opacity:.7;fill:#8bcde5}.b{fill:#8bcde5}.c{fill:#fff}.d{fill:#4d82a3}.e{fill:#dc903c}.f{opacity:.1;fill:#2b3448}.g{fill:#74471b}.h{fill:#5ca28b}.i{fill:#2b3448}.j{opacity:.2;mix-blend-mode:overlay;fill:#fff}.k{fill:#ecb751}.l{fill:#de6c6b}.m{opacity:.4;fill:#2b3448}.n{opacity:.1;fill:#74471b}.o{opacity:.1;fill:#fff}.p{fill:none;stroke:#2b3448;stroke-miterlimit:10;stroke-width:2}.q{opacity:.3;fill:#dc903c}.r{opacity:.2;fill:#2b3448}.s{opacity:.3;fill:#74471b}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m10.3 632c0 39.8 193 72.1 431.1 72.1 238 0 431-32.3 431-72.1 0-39.8-193-72.1-431-72.1-238.1 0-431.1 32.3-431.1 72.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m441.4 559.9c-232.5 0-421.9 30.8-430.7 69.3-22-40.5-8.8-97.7 28.8-123.2 9.6-6.4 20.4-11.1 28.9-19.1 26.1-24.6 19.2-67.8 25.9-103.7 7.1-38.5 33.2-72.7 67.7-88.8 36.9-17.1 82.1-14.8 113.9-40.7 28.2-23 38.2-61.9 54.5-95.1 37.3-76 115.3-126.9 197.2-136.2 81.8-9.2 165.7 21.1 229.2 75.4 33.9 29.1 63.1 66 75.5 109.8 18.7 66.4-3.4 136.8-10.9 205.6-1.1 9.4-1.8 19.1 1.1 28.1 6.8 20.8 29.9 29.8 44.9 45.2 30.5 31.5 24 83.4 15.4 127.1l-10.4 18c-1.4-39.6-193.8-71.7-431-71.7z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m858.7 635.7c0 7-32.6 12.7-72.8 12.7-40.2 0-72.8-5.7-72.8-12.7 0-7 32.6-12.6 72.8-12.6 40.2 0 72.8 5.6 72.8 12.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m140.3 73.9l-9.2-27.3-27.6-8.5 28.3-9.7 8.9-28.5 9.3 27.3 27.5 8.5-28.8 10.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m684.7 169.6l-9.3-27.3-27.5-8.5 28.2-9.8 9-28.4 9.3 27.2 27.5 8.6-28.8 10.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m768.4 187.4l-4.7-13.9-14.1-4.3 14.4-5 4.6-14.5 4.7 13.9 14.1 4.4-14.7 5.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m129.4 409.2l-4.7-13.9-14-4.4 14.3-4.9 4.6-14.6 4.7 13.9 14.1 4.4-14.7 5.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m719.5 221.5l-4.8-13.9-14-4.3 14.4-5 4.6-14.5 4.7 13.9 14 4.3-14.7 5.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m214.9 159.1l-4.8-13.9-14-4.3 14.4-5 4.6-14.5 4.7 13.9 14 4.4-14.7 5.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m181.9 94.8c0 2.2-1.9 4.1-4.2 4.1-2.2 0-4.1-1.9-4.1-4.1 0-2.3 1.9-4.2 4.1-4.2 2.3 0 4.2 1.9 4.2 4.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m822.9 290.8c0 2.3-1.8 4.2-4.1 4.2-2.3 0-4.1-1.9-4.1-4.2 0-2.3 1.8-4.1 4.1-4.1 2.3 0 4.1 1.8 4.1 4.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m815.6 345.6c0 2.3-1.8 4.1-4.1 4.1-2.3 0-4.1-1.8-4.1-4.1 0-2.3 1.8-4.1 4.1-4.1 2.3 0 4.1 1.8 4.1 4.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m768.2 336.1c0 2.3-1.9 4.1-4.2 4.1-2.3 0-4.1-1.8-4.1-4.1 0-2.3 1.8-4.1 4.1-4.1 2.3 0 4.2 1.8 4.2 4.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m114.4 250.4c0 2.3-1.9 4.2-4.2 4.2-2.3 0-4.1-1.9-4.1-4.2 0-2.2 1.8-4.1 4.1-4.1 2.3 0 4.2 1.9 4.2 4.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m89.6 220.1c0 2.3-1.9 4.2-4.2 4.2-2.3 0-4.1-1.9-4.1-4.2 0-2.2 1.8-4.1 4.1-4.1 2.3 0 4.2 1.9 4.2 4.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m660.1 66.4c0 2.3-1.8 4.2-4.1 4.2-2.3 0-4.2-1.9-4.2-4.2 0-2.2 1.9-4.1 4.2-4.1 2.3 0 4.1 1.9 4.1 4.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m221.3 399.9c-21.1-30.6-40.7-62.3-57.4-95.5-13.4-26.6-24.9-54.3-33.6-82.8q1-29.5 2-59c0.8-23.4 0.5-49.7-16-66.3-4.1-4-9.8-7.4-15.3-5.9-6.4 1.8-9.3 9.2-10.6 15.8-8.1 40.7 9.7 81.9 33.5 116.4q4.1 13.5 9 26.7c12.8 34.7 29.5 67.8 48.3 99.5 10.7 18 22 35.5 33.9 52.7 1.1 1.6 6.7-0.8 6.2-1.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m201.8 384.3c-10.1-25.5-18.9-51.6-25.4-78.2-5.2-21.4-8.8-43.2-10.3-65.2q5.6-21.1 11.2-42.1c4.5-16.7 8.7-35.7-0.4-50.3-2.3-3.6-5.8-7-10-6.8-5 0.2-8.3 5-10.3 9.5-12.6 28-6.7 60.6 4.7 89.4q0.7 10.3 2 20.7c3.5 27 9.9 53.6 18.2 79.6 4.6 14.7 9.9 29.2 15.6 43.5 0.5 1.3 4.9 0.6 4.7-0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m278.5 388.4c-26.4-7.6-52.4-16.6-77.4-27.8-20.1-9-39.6-19.4-57.9-31.6q-13.2-17.4-26.5-34.7c-10.4-13.8-22.9-28.7-40-30.4-4.2-0.5-9.1 0.3-11.5 3.7-2.9 4-1.1 9.6 1.2 14 14.5 27.1 43.9 42.3 73.6 50.9q8.6 5.8 17.6 11.1c23.5 13.8 48.5 25 74.1 34.3 14.5 5.3 29.2 10 44 14.3 1.4 0.4 3.5-3.6 2.8-3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m624.8 445.8c24.6-20.9 48.2-43.1 69.6-67.2 17.3-19.4 33.1-40 46.9-62q5.8-25 11.6-50c4.6-19.8 10.7-41.8 28.3-52 4.3-2.5 9.9-4.1 14.2-1.5 5 2.9 5.7 9.8 5.4 15.6-2.5 36-26.6 66.6-54.4 90.2q-6.5 10.4-13.6 20.4c-18.5 26.2-39.9 50.2-62.9 72.7-13 12.6-26.5 24.8-40.3 36.5-1.2 1.1-5.4-2.2-4.8-2.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m644.7 437.1c14.2-19.2 27.4-39.1 38.9-60 9.1-16.8 17.1-34.2 23.3-52.3q0-19 0-37.9c0-15 0.8-31.9 11.7-42.2 2.7-2.5 6.4-4.5 10-3.4 4.1 1.3 5.8 6.1 6.4 10.3 4.3 26.3-8 52.4-24 73.9q-2.9 8.6-6.4 17c-9 21.9-20.3 42.8-33.1 62.7-7.2 11.3-14.9 22.3-22.9 33.1-0.7 0.9-4.3-0.7-3.9-1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m579.4 423.3c23.8-0.5 47.7-2.2 71.2-5.9 18.9-3.1 37.6-7.4 55.7-13.6q15-11.6 30-23.2c11.9-9.1 25.7-18.8 40.5-16.5 3.6 0.6 7.5 2.3 8.8 5.8 1.5 4-1.3 8.3-4.2 11.4-18.2 19.5-46.3 25.7-73.2 26.2q-8.6 2.9-17.3 5.3c-22.8 6.3-46.3 10.1-69.9 12.2-13.4 1.2-26.8 1.8-40.1 2.1-1.3 0-2.1-3.8-1.5-3.8z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m856.9 568.6c0-5.1-0.6-10-1.7-14.8h-1.1c-2-8.9-28.7-15.9-61.3-15.9-33.9 0-61.4 7.6-61.4 17q0 0.4 0.1 0.8c-0.8 4.2-1.3 8.5-1.3 12.9 0 25.8 15.4 48 37.6 57.9-5.4 1.5-8.7 3.4-8.7 5.5 0 4.5 15.4 8.2 34.4 8.2 19.1 0 34.5-3.7 34.5-8.2 0-2.1-3.3-4-8.7-5.5 22.2-9.9 37.6-32.1 37.6-57.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m856.9 568.6c0-5.1-0.6-10-1.7-14.8h-1.1c-0.7-2.9-4-5.6-9.3-7.9 3.2 4.9 5.3 10.6 5.8 17.2 1.3 16.5-8.4 33.9-22.1 42.8-13.9 9-31.7 9.5-47.3 5.5-22.7-5.9-42.7-21.9-51-42.8q0 0 0 0c0 25.8 15.4 48 37.6 57.9-5.4 1.5-8.7 3.4-8.7 5.5 0 4.5 15.4 8.2 34.4 8.2 19.1 0 34.5-3.7 34.5-8.2 0-2.1-3.3-4-8.7-5.5 22.2-9.9 37.6-32.1 37.6-57.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m842.6 554.9c0 7.6-22.3 13.7-49.8 13.7-27.4 0-49.7-6.1-49.7-13.7 0-7.6 22.3-13.7 49.7-13.7 27.5 0 49.8 6.1 49.8 13.7z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m793.2 561.6c-9.6-5.9-19.3-12-26.6-20.6-7.3-8.6-11.9-20.3-9.3-31.3 1.3-5.4 4.2-10.5 4.1-16-0.3-11.7-12.9-18.5-19.8-27.8-8.4-11.3-8.3-26.5-8-40.5 5.2 15.3 22.7 21.8 35.1 32.2 13.7 11.4 21.4 28.7 24.8 46.3 3.3 17.5 2.6 35.6 1.8 53.4z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m778.9 486.5c-9.3-23.6-32.4-36.9-45.3-57.4-0.3 12.9 0.4 26.5 8 36.7 6.9 9.4 19.5 16.2 19.8 27.9 0.1 5.5-2.8 10.6-4.1 16-2.6 11 2 22.7 9.3 31.3 5.7 6.7 13 11.9 20.5 16.7 1.5-24.3 0.6-48.8-8.2-71.2z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m793.2 561.5c-12.6-15.2-15.9-37.5-8.2-55.6 5.3-12.5 15.4-23.3 16.7-36.8 0.6-6.7-1-13.4-1.2-20.2-0.2-9.4 2.4-18.8 7.5-26.7-2.7 27.8 17.1 53.4 17 81.3-0.1 21.4-31.8 58-31.8 58z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m808.2 456.9c0.6 21.8-2.6 42.3-7.6 63.5-2.7 11.3-3.7 21.3-1.8 31.4 15.8-10.6 26.1-29.2 26.2-48.3 0.1-23.5-14-45.5-16.8-68.4-0.6 7.2-0.2 14.6 0 21.8z"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m793 561.4c0.1-17.8 0.9-37.5 13.1-50.5 10.3-11 26.9-15 35.3-27.5 7.4-10.8 6.4-24.9 9.5-37.6 3-13 10.5-24.8 20.9-33.1q1.7 19.4 3.5 38.9c1.4 15.5 2.7 31.5-2.1 46.3-5.1 15.8-16.7 28.7-30.1 38.3-13.5 9.6-28.8 16.2-43.9 22.7z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m872.8 423.7c-4.9 13-7 27.1-11.3 40.3-6.7 20-17.7 36.5-32 51.8-12.8 13.7-22.8 24.4-27 41.7 14-6.1 28.1-12.4 40.6-21.3 13.4-9.6 25-22.5 30.1-38.3 4.8-14.8 3.5-30.8 2.1-46.3q-1.3-13.9-2.5-27.9z"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m155.4 574.2l-43.4 14.2c0 0 338.7 98.1 354.5 104.4 15.8 6.3 262.7-79.1 262.7-79.1l-69.6-22.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m285.9 660.3l-210.9-49.6c-6.1-1.4-12.2 2.4-13.7 8.4-1.4 6.1 2.4 12.2 8.5 13.7l210.9 49.6z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m61.2 623.8c0.8 4.3 4.1 7.9 8.6 9l210.9 49.6 1.6-6.7z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m100.4 616.5l-5.4 22.7-5.8-1.4 5.3-22.7z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m196.2 639l-5.3 22.7-5.9-1.4 5.4-22.7z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m156.1 635.7l-0.7 3-67.3-15.9 0.7-2.9z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m280.7 682.4l20.4-3.3 1.7-7.3-16.9-11.5z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m705.8 608.7l-17.2-8c-21.9-12-7.9-83.9-7.9-83.9l-196.4 56.8-332.6-82.7c-11 41.6-2 96.3-2 96.3l307.5 84-0.1 0.3 26.9 7c229.6-66.9 221.8-69.8 221.8-69.8z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m488.7 575.1l220.5-65.9-332.3-70.9-225.2 52.6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m156.4 584.3c-1.6-6.6-2.6-13.4-3.3-20.2-0.7-6.8-0.9-13.6-0.8-20.5 0.2-6.8 0.8-13.7 2.1-20.4 1.2-6.8 3.1-13.4 5.9-19.7-0.9 3.3-2 6.6-2.5 9.9-0.8 3.3-1.3 6.7-1.8 10-0.8 6.7-1.4 13.5-1.6 20.3-0.2 6.7 0 13.5 0.3 20.3q0.2 5.1 0.7 10.2c0.2 3.4 0.6 6.7 1 10.1z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m467 667.8c-1.7-6.6-2.7-13.4-3.4-20.2-0.7-6.8-0.9-13.7-0.7-20.5 0.2-6.9 0.8-13.7 2-20.5 1.3-6.7 3.2-13.4 5.9-19.6-0.8 3.3-1.9 6.5-2.5 9.9-0.8 3.3-1.2 6.6-1.8 10-0.8 6.7-1.4 13.4-1.5 20.2-0.2 6.8 0 13.6 0.3 20.4q0.2 5 0.7 10.1c0.2 3.4 0.6 6.8 1 10.2z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m170.2 501.8c24 5.9 47.9 12 71.8 18.2l71.8 18.7 71.6 19.3 35.7 9.8 35.7 10-36-9-35.9-9.2-71.7-18.8-71.6-19.2c-23.8-6.5-47.7-13.1-71.4-19.8z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m231.9 603.8l-65.9-19.3 3.8-75.4 64.8 17.2zm-63.7-20l61.5 17.9 2.6-74.8-60.5-16z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m200.2 557.1l-30.7-27.9 32.3-10.5 31.5 27.9zm-27.7-27.1l27.7 25.2 29.9-9.5-28.4-25.2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m198.2 577.1l-30.8-28.3 32.5-10.5 31.5 28.3zm-27.7-27.4l27.8 25.5 30-9.4-28.5-25.5z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m197.5 593.6l-30.9-28.7 32.6-10.4 31.7 28.7zm-27.9-27.8l27.9 25.9 30.1-9.3-28.6-25.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m304.6 624.8l-65.9-19.3 3.8-75.4 64.8 17.2zm-63.7-20l61.5 17.9 2.6-74.8-60.5-16z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m272.9 578.1l-30.7-27.9 32.3-10.5 31.5 27.9zm-27.7-27.1l27.7 25.2 29.9-9.5-28.4-25.2z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m270.9 598.1l-30.7-28.3 32.4-10.5 31.6 28.3zm-27.8-27.4l27.8 25.5 30-9.4-28.5-25.5z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m270.2 614.6l-30.9-28.7 32.6-10.4 31.7 28.7zm-27.9-27.8l28 25.9 30-9.3-28.5-25.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m379.4 645.8l-65.9-19.3 3.8-75.4 64.8 17.2zm-63.7-20l61.5 17.9 2.6-74.7-60.5-16.1z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m347.7 599.1l-30.7-27.9 32.3-10.5 31.5 27.9zm-27.7-27.1l27.7 25.2 29.8-9.5-28.3-25.2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m345.7 619.1l-30.8-28.3 32.5-10.5 31.5 28.4zm-27.7-27.5l27.8 25.6 30-9.4-28.5-25.6z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m345 635.6l-30.9-28.7 32.6-10.4 31.7 28.7zm-27.9-27.8l27.9 25.9 30.1-9.3-28.6-25.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m454.3 665.8l-65.9-19.3 3.7-75.5 64.9 17.2zm-63.7-20l61.4 18 2.7-74.8-60.5-16z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m422.5 619l-30.7-27.8 32.4-10.6 31.4 27.9zm-27.6-27l27.7 25.1 29.8-9.5-28.3-25.2z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m420.6 639l-30.8-28.3 32.4-10.4 31.6 28.3zm-27.7-27.5l27.8 25.6 29.9-9.4-28.4-25.6z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c",
    d: "m419.9 655.5l-30.9-28.7 32.6-10.3 31.6 28.7zm-27.8-27.8l27.9 25.8 30-9.3-28.5-25.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp1)"
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m490.5 571.6c0 0-26.1 52.4-8.2 101.7l214.1-69.3c0 0-13.9-47.2 3-88.8z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m653.9 609.7c-29.6 11.3-59 20.2-90.7 22.6-31.4 2.3-63.6-5.4-82.9-31.1-4.7 19.5-7.4 46.2 2 72.1l214.1-69.3c0 0-1-3.6-2.2-9.7-13.6 4.8-26.9 10.2-40.3 15.4z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m471 592.6l-0.4-1.5 232.4-51.6 0.3 1.5z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m471.7 609.2l-0.3-1.6 231.5-55.2 0.3 1.5z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m469.9 626.3l-0.4-1.6 231.5-55.2 0.4 1.5z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m469.3 641.3l-0.4-1.6 230.6-58.8 0.4 1.5z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m472.1 661.2l-0.4-1.5 228.6-66.2 0.4 1.6z"
  })))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m477.6 581.3l-327-85.1c0 0-5.2 22-2.1 34.7l327 87.2 9.5-35.7z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m149.7 587.2l334.3 91.3c0 0-7.4-30.9-7.4-34.1l-328.1-83.1c0 0-1.9 20.3 1.2 25.9z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m211.2 409.2c0 0-6 36.9-1 60.9 0 0 207.6 112.8 222.6 116.7 15 4 301.4-50.9 301.4-50.9l-37.9-8.9-1.8-67.6 34.7-6.3-241.5-96.8z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m706.3 457.1l-269.5 42.9c0 0-15.7 49.6 0 76.9l277-47c0 0-6.5-34.9-7.5-72.8z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m570 546.4c-46.6 1.8-97.6 0.2-138.7-20.8-2.3 16.3-2.8 36.9 5.5 51.3l277-47c0 0-0.1-0.5-0.2-1.5-47.4 9.4-95.4 16.2-143.6 18z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m233.3 422.4l-11.8-4.6-5.9 24.4 5.3 28.8 11.5 6 6.5-24.2z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m229.7 436.4l-5.2-2.2-2.7 10.8 2.4 13 5.2 2.5 2.8-10.7z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m239 480.4l-23.7-12.3 0.4-53.1 24.4 9.6z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m306.1 451l-16.1-6.3-8.9 27.5 6.2 33.4 15.5 8 9.9-27z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m300.6 466.8l-7.1-3-4 12.2 2.8 15.1 6.9 3.4 4.3-12.1z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m311.7 518.3l-31.9-16.6 2.5-60.6 33.1 13z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m408.6 491.3l-23.2-9.1-14 31.3 7.4 39.7 22 11.5 15.8-30.5z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m399.9 509.4l-10.2-4.3-6.4 13.8 3.3 18.1 10 4.8 6.7-13.7z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m413.7 571.4l-45.4-23.6 6.1-70.6 47.8 18.7z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m260.8 492l-5.1-2.7 1.6-58 5.3 2.1z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m340 533.3l-6.8-3.6 4.6-66.9 7.1 2.8z"
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m211.2 409.2l225.6 90.8c0 0-7.2 27.5-6.7 34l-221.4-102.9c0 0 1.2-19.6 2.5-21.9z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m210.2 470.1l222.6 116.7c0 0-9.2-13.5-8.6-37.8l-215.5-98.5c0 0 0.3 17.1 1.5 19.6z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m425.1 514.5l-0.2-1 288.4-47.9 0.2 1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m426.1 526.5l-0.2-1 288.4-47.9 0.1 1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m425 539.8l-0.2-1.1 288.4-47.8 0.1 1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m425.5 553l-0.1-1.1 288.3-47.8 0.2 1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m426.1 567.5l-0.2-1.1 288.4-47.8 0.2 1z"
  })))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m176.3 301.4c0 0-22 43.9-1 93.8l295.4 91.8 223.6-61.3-18.9-4.7-4.2-83.8 21.1-5.9-279.5-83.8z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m674.9 336.1l-209.2 44.1c0 0-31.9 59.9 9 96.9l202.6-55.9z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m587.9 355.1c7.6 0 15.2-0.3 22.8-0.9 3.4-0.2 6.8-0.6 10.2-1q0.9-0.1 1.4-0.2 1.2-0.1 2.3-0.3c12.9-2.2 25.6-4.9 38.2-8.2q6.1-1.6 12.2-3.4l-0.1-5-89.9 19q1.4 0 2.9 0z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m583.7 429.5c-30-0.3-59.9-3.5-89.8-5.5-13.3-1-26.6-2.3-39.5-5-2 18.8 1.3 40.9 20.3 58.1l202.6-55.9-0.1-4.2c-30.5 7.6-61.4 12.8-93.5 12.5z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m179.2 390.7c-3.1-6.6-4.9-13.7-6.1-20.8-1.3-7.2-1.8-14.5-1.6-21.8 0-1.8 0.2-3.6 0.2-5.4l0.2-2.7 0.3-2.8 0.7-5.4 1-5.3c0.6-3.6 1.7-7.1 2.6-10.6 1-3.5 2.3-6.9 3.5-10.3-1.7 7.1-3.5 14.1-4.5 21.2l-0.8 5.3-0.5 5.3-0.2 2.7-0.2 2.7c-0.1 1.8-0.2 3.6-0.2 5.4-0.2 7.1 0.2 14.3 1.1 21.4 0.4 3.6 1 7.1 1.7 10.6 0.8 3.6 1.7 7 2.8 10.5z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m448.5 472.7c-3.1-6.5-4.9-13.6-6.1-20.8-1.3-7.1-1.7-14.4-1.6-21.7 0-1.8 0.2-3.6 0.3-5.5l0.1-2.7 0.3-2.7 0.7-5.4 1-5.4c0.6-3.5 1.7-7 2.6-10.5 1-3.5 2.3-6.9 3.5-10.3-1.7 7-3.4 14-4.5 21.1l-0.7 5.4-0.6 5.3-0.2 2.7-0.2 2.7c0 1.8-0.2 3.5-0.2 5.3-0.2 7.2 0.2 14.4 1.1 21.5 0.4 3.6 1 7.1 1.8 10.6 0.7 3.5 1.6 7 2.7 10.4z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m203.9 370.5l41.8 7.1-36.5-28.7-20 2.7z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m209.7 347.6l39.6 30.9-25.4-47.2-21.1-8.9z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m203.8 372.7l44.6 6.8-39.5 14.8-18.8-8.6z"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m268 335.4c0 0-18.4 43.2-6.4 84.8l46.3 16c0 0-10.3-69.6 10.4-85.6z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m371.1 366.6c0 0-19.2 47.2-6.4 86.4l14.4 5.6c0 0-4-65.6 10.4-87.2z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp3)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m456.4 389.9l-0.2-1.1 240.1-52.1 0.2 1z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m452.8 403.1l-0.3-1 239.8-53.7 0.3 1z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m450.8 417.6l-0.2-1.1 238.8-57.7 0.3 1z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m449.8 429.3l-0.3-1.1 238.9-57.7 0.2 1z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m450.1 440.9l-0.3-1 238.9-57.8 0.2 1.1z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m451.7 451.9l-0.2-1.1 238.8-57.7 0.3 1z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m462.3 472.4l-0.3-1 238-60.9 0.3 1z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m456.8 461.4l-0.3-1.1 238.9-57.7 0.2 1z"
  })))), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m176.3 301.4l289.4 78.8c0 0-11.4 28-13 41.6l-286.3-88c0 0 4.6-27.3 9.9-32.4z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m172.8 394.6l297.9 92.4c0 0-16.6-6.5-22-35.6l-282.3-85.6c0 0 4 24 6.4 28.8z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m199.2 203.6c0 0-6.9 59.9-1 75.8l222.6 90.9 268.5-46.9-27-6-3.1-64.6 23.6-2.6-268-78.6z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m666.3 252.5l-238.5 30.9c0 0-27.9 52.9 7 74.9l233.5-37.9c0 0-2-70.9-2-67.9z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m572.6 332.8c-29.3-0.2-59-2.7-88.1-5.2-17.4-1.5-35.3-3.5-51-11.6-5.1-2.6-9.7-5.9-14.1-9.5-4 17.1-4.4 39.4 15.4 51.8l159.4-25.9q-10.9 0.4-21.6 0.4z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m217.3 249.7c0 0.7-0.9 0.9-1.9 0.5-1-0.4-1.7-1.2-1.7-1.9 0-0.6 0.9-0.8 1.8-0.4 1 0.3 1.8 1.2 1.8 1.8z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m246 241.8c0 0.7-0.9 0.9-2 0.6-1.1-0.4-1.9-1.3-1.9-2 0.1-0.6 1-0.9 2-0.5 1.1 0.4 1.9 1.3 1.9 1.9z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m244 279c-0.1 0.7-1 0.8-2 0.4-1.1-0.4-1.9-1.3-1.9-2 0.1-0.6 1-0.8 2-0.4 1.1 0.4 1.9 1.3 1.9 2z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m274.4 272c0 0.7-1 0.9-2.1 0.4-1.2-0.4-2-1.3-2-2 0-0.7 1-0.9 2.1-0.5 1.2 0.5 2.1 1.4 2 2.1z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "k",
    d: "m286.1 242.9l-4.3 64.1-76.6-32.4 1.3-28.5-0.3-0.3 0.3-0.1 1.3-30zm-58.1-3.6l14.2 17.6 0.6-10.9 2.3 0.8-0.6 11.3 17.4-6.9-14.8-19.4zm17.5-9l-34.6-12.1 15.8 19.5zm17.9 20.3l18.7-7.5-33.4-11.6zm2.3 17.2l-0.1 1.4-19.6-7.5 16.1 19.9 18.4-6-17.3-22.6-17.8 7zm-39.1-27.9l-17.7 7 15.6 19.2 16.2-6.5-19.5-7.5 0.1-1.4 20.2 7.8zm-0.7 27.7l16.5 20.3 18.2-5.9-16.3-20.2-0.7 13-2.2-0.9 0.6-12.6zm-1.4 0.5l-16 6.4 32.2 13.5zm19.6 21.3l34.1 14.4-16.2-20.1zm35.5 13.5l1.7-25.5-17.7 5.7zm1.9-29.1l2-29.1-18.6 7.4zm-72.9-29.2l16.6-6.5-15.5-19.2zm-0.1 3.7l-1.1 24.3 15.7-6.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m331.9 291.4c0 0.7-0.8 0.9-1.8 0.5-1-0.4-1.8-1.2-1.8-1.9 0.1-0.6 0.9-0.8 1.9-0.4 1 0.3 1.7 1.2 1.7 1.8z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m360.6 283.5c0 0.7-0.9 0.9-2 0.6-1-0.4-1.9-1.3-1.8-2 0-0.7 0.9-0.9 2-0.5 1 0.4 1.9 1.2 1.8 1.9z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m358.6 320.7c-0.1 0.7-0.9 0.8-2 0.4-1-0.4-1.9-1.3-1.8-2 0-0.6 0.9-0.8 1.9-0.4 1.1 0.4 1.9 1.3 1.9 2z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m389 313.7c0 0.7-1 0.9-2.1 0.4-1.1-0.4-2-1.3-2-2 0.1-0.7 1-0.9 2.2-0.5 1.1 0.5 2 1.4 1.9 2.1z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "k",
    d: "m400.7 284.6l-4.3 64.1-76.6-32.4 1.3-28.5-0.3-0.3 0.3-0.1 1.3-30zm-58-3.6l14.2 17.6 0.6-10.9 2.2 0.8-0.6 11.3 17.4-7-14.8-19.3zm17.5-9l-34.6-12.1 15.8 19.5zm17.9 20.3l18.7-7.5-33.3-11.7zm2.2 17.3l-0.1 1.4-19.5-7.5 16 19.9 18.5-6-17.4-22.7-17.7 7.1zm-39.2-27.9l-17.7 7 15.7 19.2 16.2-6.5-19.5-7.5v-1.4l20.2 7.7zm-0.7 27.8l16.5 20.3 18.2-5.9-16.3-20.2-0.7 13-2.2-0.9 0.7-12.6zm-1.4 0.5l-16.1 6.4 32.2 13.5zm19.6 21.3l34.1 14.4-16.2-20.2zm35.6 13.6l1.6-25.5-17.7 5.7zm2-29.1l1.9-29.1-18.6 7.4zm-72.9-29.2l16.7-6.6-15.5-19.1zm-0.2 3.7l-1.1 24.3 15.8-6.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp4)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m413.6 315l-0.2-1.1 270.5-36 0.1 1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m413.6 331.9l-0.2-1.1 270.5-36 0.1 1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m413.8 350.3l-0.2-1.1 270.1-39 0.1 1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m413.3 296l-0.1-1 271-31.9 0.1 1z"
  })))), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m478.9 287.4c0 0 30.4 45.1 23.6 101.4l14.7-12.4 11.3 11.3c0 0 1.1-76.6-19.2-102.5z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m199.2 203.6c0 0 223.3 71.4 223.3 74.8 0 3.4-14.6 27.1-11.2 49.6l-214.1-84.5z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m659.1 264.1h-406.2v-64.8h406.2z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m659.1 264.1h-406.2v-13.9h406.2z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m659.1 223.2h-406.2v-23.9h406.2z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m310.6 199.3h-35.7v64.8h35.7z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m342.2 199.3h-6.1v64.8h6.1z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m570.9 199.3h-203.2v64.8h203.2z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m621.6 199.3h-25.2v64.8h25.2z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m252.9 199.3l-3-50.9 373.3-3 35.9 53.9z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m271.9 113.4v57.9l257.5 28 97.8-31-13-5 1-46.9 10-4-240.6-21.9z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m620.2 114.2l-91.8 25.2v47.9 6l90.5-28.7z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m509.2 152.1l-227.6-25.9 0.2-2.1 227.6 25.9z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m508.1 165.7l-227.7-26 0.3-2.1 227.6 26z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m508.1 179.2l-227.7-25.9 0.3-2.1 227.6 25.9z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m508.1 191.6l-227.7-25.9 0.3-2.1 227.6 25.9z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp5)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m523.1 147.8l-0.2-1 110-29.6 0.3 1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m524.3 161.3l-0.3-1 110.1-29.6 0.2 1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m524.5 173.3l-0.3-1 110-29.6 0.3 1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m525.6 185.7l-0.3-1 110.1-29.6 0.2 1z"
  })))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m271.9 171.3l257.5 28-0.9-23.4-255.8-25.9z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m271.9 113.4l256.5 26 0.1 13.9-255.8-22.5z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m528.4 139.4v53.9l81.2-26.4c0 0-80.2 23.9-81.2-27.5z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m234.8 51c0 0-11.8 24-1.5 47l213.8 40.8 181-29-13.7-2.4 2.4-47.1 10.8-2.5-212.8-35.3c0 0-172.7 18.7-180 28.5z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp6)"
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m457.3 88.7c0 0-16.2 22.6-3.5 45.6l162.9-26.9 2.4-47.1z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m540.2 119.9c-18.5-0.3-38.5-0.8-56.5-5.6-11.7-3.2-21.6-9.4-31.4-16-3.4 8.7-6.1 22.3 1.5 36l86.9-14.3q-0.2-0.1-0.5-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m439.5 98.6l-0.1-1 194.9-31.5 0.2 1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m439.5 109.9l-0.1-1 194.9-31.6 0.2 1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m439.5 121.2l-0.1-1.1 194.9-31.5 0.2 1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m439.5 130.2l-0.1-1 194.9-31.6 0.2 1z"
  })))), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m453.6 49.3c10.3 1.8 11.7 4.3 3 5.7-8.7 1.4-24.1 1.2-34.5-0.6-10.4-1.7-11.8-4.3-3.1-5.7 8.7-1.4 24.2-1.1 34.6 0.6z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m409.3 48.2c-4.4 0.2-9.6 0.2-14.4-0.1-2.4-0.2-4.8-0.4-6.7-0.7-5.1-0.9-6-2.1-8.1-3.1-4.5-2.2-16.3-4.1-29.5-4.9 11.3-0.2 23.8-0.3 34.4 0.8 11.5 1.3 16.7 3.6 22.1 5.6 2.1 0.8 4.3 1.5 6.4 2.3z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m463.1 56.1c4.4-0.2 9.5-0.2 14.3 0.1 2.4 0.2 4.8 0.4 6.7 0.7 5.1 0.8 5.9 2 8.1 3.1 4.4 2.2 16.1 4.1 29.2 4.8-11.1 0.2-23.5 0.4-34.1-0.7-11.5-1.3-16.6-3.6-22-5.6-2.1-0.8-4.3-1.6-6.4-2.3z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m430.4 46.7c-4.7-0.4-8.7-1-11.5-1.8-1.3-0.4-2.4-0.8-2.6-1.2-0.8-1.1 3.7-1.8 6.4-2.7 5.7-1.8 4.1-4.3-3.9-6.2 10.5 1.2 21.8 2.6 25.8 4.5 4.3 2.1-1.4 4-5.6 5.8-1.6 0.7-3 1.4-4.6 2.1z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m442.1 57.6c4.6 0.4 8.7 1 11.4 1.8 1.3 0.4 2.4 0.8 2.6 1.2 0.8 1-3.7 1.8-6.4 2.7-5.7 1.8-4.1 4.3 3.9 6.2-10.5-1.2-21.7-2.6-25.8-4.5-4.3-2.1 1.4-4 5.6-5.8 1.6-0.7 3-1.4 4.6-2.1z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m451.7 48c-2.6-0.8-3.8-1.6-3.3-2.4 0.2-0.4 0.8-0.8 2.1-1.1 3.5-0.8 10.5-0.8 16.3-1.1 11.9-0.5 20-2.4 20.4-4.5 4.8 1.9 9.6 4 5.9 5.7-4 1.8-16.5 2.5-27.3 3.2-4 0.3-8 0.6-12 0.9z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m420.7 56.3c2.6 0.8 3.8 1.7 3.3 2.4-0.2 0.4-0.8 0.8-2.1 1.1-3.5 0.8-10.5 0.8-16.3 1.1-11.9 0.6-20.1 2.4-20.5 4.5-4.8-1.9-9.7-4-5.9-5.7 4-1.8 16.6-2.5 27.3-3.2 4.1-0.3 8.1-0.6 12.2-0.9z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m468 51.9c1.4-0.7 4.3-1.3 8.3-1.6 1.9-0.2 4.2-0.3 6.6-0.3 6.3 0 12.3 0.9 18.2 1.5 12.3 1.2 27.2 1.3 37.2 0.2-4.7 1.6-10.4 3.3-21.1 3.7-11.6 0.4-24.8-0.8-36.9-1.8-4.6-0.3-9.3-0.7-13.9-1z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m404.4 52.4c-1.4 0.7-4.4 1.3-8.3 1.6-2 0.2-4.2 0.3-6.7 0.3-6.4 0-12.3-0.9-18.3-1.5-12.4-1.2-27.4-1.3-37.6-0.2 4.8-1.6 10.5-3.3 21.4-3.7 11.7-0.4 24.9 0.8 37.2 1.8 4.6 0.3 9.2 0.7 13.8 1z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m260.4 55.6c0 0-14.4 28.3 1.1 48l18.1 3.2c0 0-9.6-33.6 4.3-48z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m387.8 80.3c0 0-14.3 28.3 1.1 48l18.1 3.2c0 0-9.6-33.6 4.3-48z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m234.8 51l222.5 37.7c0 0-8.8 13.5-9.6 24l-218.9-39.7c0 0 1.4-18.2 6-22z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m444.9 87.9l-197.2-34.9 0.4-2.1 197.2 34.9z"
  }))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "m446.2 131q-0.8-2.9-1.4-5.8l-215.2-36 3.7 8.8 213.8 40.8c-1.3-2.5-1.3-5.4-0.9-7.8z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m263.6 43c0 0 82.6-14.2 151.2-20.5l126.1 20.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookStoreHome2);
export default __webpack_public_path__ + "static/media/bookStore-home2.0a2bfddfc8bc03f17296818af9e7648f.svg";
export { ForwardRef as ReactComponent };